import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { IStrapiDocument, TsAndCs } from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgIf,
        PageRetrievalErrorComponent,
        RenderMarkdownComponent,
    ],
})
export class TermsAndConditionsComponent
  extends PageComponent
  implements OnInit
{
  public override pageData: TsAndCs = <TsAndCs>{};

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,
    public override readonly strapi: StrapiService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentsByType('terms-and-condition', {
        populate: {
          banner: {
            populate: {
              slides: { populate: ['image'] },
            },
          },
        },
      })
      .subscribe((data: IStrapiDocument<TsAndCs>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.cdr.markForCheck();
      });
  }

  protected override parsePageData(page: TsAndCs): void {
    this.pageData.content = page.content;
    this.pageData.markdown = page.markdown;

    super.parsePageData(page);
  }
}
